<template>
  <div class="optional-container">
    <div class="title">{{ title }}</div>
    <div class="optional-item" v-for="(item, index) in giftsList" :key="index" @click="handleSelect(item)">
      <div
        :class="['select-item', { selected: item.canOptional == 1 }]"
        v-track="{
          act: 'click',
          params: {
            cfrom: '160|004|01|077',
            event_id: '160|004|01|077',
            page_name: customParams.page_name,
            sku_id: skuId,
            gift_type: item.giftFlag,
            gift_content: contentChange(item),
            position: index + 1,
            isno_choose: 1
          }
        }"
      ></div>
      <GiftItem
        :skuId="skuId"
        :item="item"
        :showTypeIcon="showTypeIcon"
        :positionKey="index"
        isOptional
        :customParams="customParams"
      ></GiftItem>
    </div>
  </div>
</template>

<script>
import GiftItem from '../gift-item'

export default {
  name: 'OptionalGifts',
  components: {
    GiftItem
  },
  props: {
    showTypeIcon: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    },
    optionalGiftId: [Number, String],
    selectNums: Number,
    skuId: [Number, String],
    customParams: Object
  },
  computed: {
    title() {
      return `以下赠品${this.giftsList.length}选${this.selectNums}，已选${this.selectedList.length}件`
    }
  },
  watch: {
    list: {
      handler(newVal) {
        this.giftsList = newVal
        this.selectedList = this.giftsList.filter(item => item.canOptional)
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      selectedList: [],
      giftsList: []
    }
  },
  mounted() {
    //
  },
  methods: {
    handleSelect(item) {
      if (this.selectNums == 1) {
        if (this.selectedList.includes(item)) {
          this.selectedList.splice(0, 1)[0].canOptional = 0
        } else {
          let obj = this.selectedList.splice(0, 1, item)[0]
          if (obj) {
            obj.canOptional = 0
          }
          item.canOptional = 1
        }
      } else if (this.selectedList.length == this.selectNums && !this.selectedList.includes(item)) {
        this.$toast(`最多选择${this.selectNums}件，可取消已选赠品后再选择`)
        this.$track({
          cfrom: '159|003|02|077',
          event_id: '159|003|02|077',
          page_name: this.customParams.page_name
        })
      } else if (this.selectedList.includes(item)) {
        this.selectedList.splice(this.selectedList.indexOf(item), 1)[0].canOptional = 0
      } else {
        this.selectedList.push(item)
        item.canOptional = 1
      }
      this.$emit(
        'select',
        this.optionalGiftId,
        this.selectedList.map(v => v.id)
      )
    },
    contentChange(item) {
      let content
      // giftType 赠品活动类型：41：常规赠品 42：会员加赠 43：整点加赠 44：仅赠券
      // gift_content##内容id(1:整点加赠;2:常规赠品;3:会员加赠)
      if (item.giftType == 41) {
        content = 2
      } else if (item.giftType == 42) {
        content = 3
      } else if (item.giftType == 43) {
        content = 1
      }
      return content
    }
  }
}
</script>

<style scoped lang="scss" src="./index.scss" />
